import request from '@/utils/request'
import { Message } from 'element-ui'
import _ from 'lodash'

// const header = { 'content-type': 'application/json' }
// const token_type = 'Bearer'
// const acc_token = ''
// const acc_token_header_key = 'Authorization'

/**
 * 分页查询聊天记录-按时间逆排序
 */
export const getChatPage = async (params) => {
  const param = _.cloneDeep(params)
  const requestPayload = {}

  const form = {
    ...Object.fromEntries(
      Object.entries(param).filter((item) => {
        const isTrue = item[0] !== 'current' && item[0] !== 'size'
        if (!isTrue) requestPayload[item[0]] = item[1]
        return isTrue
      })
    )
  }

  const data = await request({
    url: '/chat/page',
    method: 'POST',
    data: form,
    params: requestPayload
  })
  if (!data.success) {
    Message.error(data.message || '聊天记录获取失败')
    return Promise.reject(new Error(data.message || '聊天记录获取失败'))
  }
  return data
}
